import clsx from 'clsx';
import Image from 'next/image';
import { Book } from '../../lib/guideBooks';

type Props = {
  book: Book;
  className?: string;
};

export const BookCover = ({ book, className }: Props) => {
  const { title, cover } = book;

  const coverUrl = cover?.url ?? null;
  const classname = clsx(
    'guide-book-cover relative flex items-center justify-center overflow-hidden border border-black/20 bg-white',
    className
  );

  return (
    <div className={classname}>
      {!coverUrl && (
        <div className="flex h-full w-full items-center justify-center bg-black/5">
          <h4 className="h4 select-none text-black/20">book cover</h4>
        </div>
      )}
      {coverUrl && (
        <Image src={coverUrl} alt={title} width={208} height={266} />
      )}
    </div>
  );
};
